import { canCreateClassicEmail, canCreateDragDropEmail, getHasAutomatedEmailsAuth, getHasFullEditorAccess, hasContextualAutomationGates
// @ts-expect-error not typed
} from 'EmailData/selectors/user';
// @ts-expect-error not typed
import DowngradeActionDisabledTooltip from 'EmailComponents/modals/actionModals/DowngradeActionDisabledTooltip';
// @ts-expect-error not typed

// @ts-expect-error not typed
import ActionTooltip from 'EmailComponents/modals/actionModals/ActionTooltip';
import { ACTION_MODAL_TYPES, DETAIL_ACTIONS, EMAIL_ACTION_TYPES } from 'EmailComponents/utils/actions/detailActionsUtil';
import { canEdit, hasEmailBeenCancelled } from 'EmailData/utils/emailActionUtils';
import { getIsAutomatedLike, getIsConvertibleToDragAndDrop, getIsDragDropEmail, getIsMembershipEmail, getIsOptinEmail, getIsSubscriptionEmail } from 'EmailData/utils/emailStateUtil';
import { canAssignEmail } from 'EmailData/utils/teams';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { gate } from 'hub-http/gates';
import { fromJS } from 'immutable';
import { ExternalLinkIcon, ReportsIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  ARCHIVE,
  ASSIGN_TEAMS,
  MOVE_TO_FOLDER,
  DELETE,
  EDIT,
  SAVE_AS_TEMPLATE,
  LOCKED_SAVE_AS_TEMPLATE,
  UNPUBLISH,
  UNARCHIVE,
  VIEW_DETAILS,
  VIEW_EMAIL,
  VIEW_PERFORMANCE,
  VIEW_INSIGHTS,
  GENERATE_TRANSLATED_VERSION
} = ACTION_MODAL_TYPES;
export const SUMMARIZE_PERFORMANCE = 'summarizePerformance';
const {
  CLONE_OR_CONVERT
} = EMAIL_ACTION_TYPES;
const {
  MANAGE_LEADFLOW
} = DETAIL_ACTIONS;
const ACTION_MAP = {
  [ARCHIVE]: {
    name: ARCHIVE,
    divider: true
  },
  [ASSIGN_TEAMS]: {
    name: ASSIGN_TEAMS,
    divider: true
  },
  [MOVE_TO_FOLDER]: {
    name: MOVE_TO_FOLDER
  },
  [GENERATE_TRANSLATED_VERSION]: {
    name: GENERATE_TRANSLATED_VERSION,
    divider: true,
    isBeta: true
  },
  [SAVE_AS_TEMPLATE]: {
    name: SAVE_AS_TEMPLATE,
    divider: true
  },
  [LOCKED_SAVE_AS_TEMPLATE]: {
    name: LOCKED_SAVE_AS_TEMPLATE,
    divider: true,
    isLocked: true
  },
  [DELETE]: {
    name: DELETE
  },
  [VIEW_DETAILS]: {
    name: VIEW_DETAILS
  },
  [EDIT]: {
    name: EDIT
  },
  [UNPUBLISH]: {
    name: UNPUBLISH
  },
  [UNARCHIVE]: {
    name: UNARCHIVE
  },
  [VIEW_EMAIL]: {
    name: VIEW_EMAIL,
    icon: ExternalLinkIcon
  },
  [VIEW_PERFORMANCE]: {
    name: VIEW_PERFORMANCE
  },
  [VIEW_INSIGHTS]: {
    name: VIEW_INSIGHTS,
    icon: ReportsIcon
  },
  [MANAGE_LEADFLOW]: {
    name: EDIT,
    i18n: {
      key: 'email-management.table.hoverActions.manageLeadflow.label'
    }
  },
  [CLONE_OR_CONVERT]: {
    name: CLONE_OR_CONVERT,
    i18n: {
      key: 'email-management.table.hoverActions.names.clone'
    }
  },
  [SUMMARIZE_PERFORMANCE]: {
    name: SUMMARIZE_PERFORMANCE,
    divider: true
  }
};
const READ_ONLY_ACTIONS = [EDIT,
// Editor has own read only mode
VIEW_PERFORMANCE, VIEW_EMAIL, VIEW_DETAILS, MANAGE_LEADFLOW];
export const saveTemplateDisabled = (email, gates, scopes) => {
  if (scopes && !scopes.includes('design-manager-access')) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(ActionTooltip, {
        message: "email-management.table.hoverActions.tooltip.saveAsTemplate.permissionDisabled"
      })
    };
  }
  if (email.isBlogEmail() || email.isBlogChildEmail() || email.isRssEmail() || email.isRssChildEmail()) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.hoverActions.tooltip.saveAsTemplate.blogRssDisabled"
      })
    };
  }
  if (email.isOptinEmail()) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.hoverActions.tooltip.saveAsTemplate.optInDisabled"
      })
    };
  }
  if (getIsMembershipEmail(email)) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.hoverActions.tooltip.saveAsTemplate.registrationEmail"
      })
    };
  }
  if (email.messageTags && (email.messageTags.includes('TEMPLATE_ERROR') || email.messageTags.includes('DELETED_TEMPLATE'))) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.hoverActions.tooltip.saveAsTemplate.template"
      })
    };
  }
  return false;
};
export const canDeleteEmail = (email, user) => user.canPublish() && !email.isLeadFlowEmail() && !email.isFeedbackEmail() && !email.isTicketEmail();
export const isEmailInReview = email => {
  var _email$messageTags$in, _email$messageTags;
  return (_email$messageTags$in = (_email$messageTags = email.messageTags) === null || _email$messageTags === void 0 ? void 0 : _email$messageTags.includes('IN_REVIEW')) !== null && _email$messageTags$in !== void 0 ? _email$messageTags$in : false;
};
export const isEmailBlocked = email => {
  var _email$messageTags$in2, _email$messageTags2;
  return (_email$messageTags$in2 = (_email$messageTags2 = email.messageTags) === null || _email$messageTags2 === void 0 ? void 0 : _email$messageTags2.includes('BLOCKED')) !== null && _email$messageTags$in2 !== void 0 ? _email$messageTags$in2 : false;
};
export const isContentUnsafe = email => {
  return isEmailBlocked(email) || isEmailInReview(email);
};
const isCloneOrConvert = action => action === CLONE_OR_CONVERT;
const isEdit = action => action === EDIT;
function all(arr) {
  return arr.every(Boolean);
}
export function disableCloneOrTranslate({
  defaultDisabled,
  defaultTooltip,
  email,
  isInternalSubscription,
  isCloning
}) {
  let disabled = defaultDisabled;
  let tooltip = defaultTooltip;
  const key = isCloning ? 'disabledCloneType' : 'disabledTranslateType';
  if (email.isLeadFlowEmail()) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.leadFlowEmail`
    });
  } else if (email.isFeedbackEmail()) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.feedbackEmail`
    });
  } else if (email.isTicketEmail()) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.ticketEmail`
    });
  } else if (email.isBlogEmail()) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.blogEmail`
    });
  } else if (email.isOptinEmail()) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.optInEmail`
    });
  } else if (isInternalSubscription) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.internalSubscription`
    });
  } else if (getIsMembershipEmail(email)) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.membershipEmail`
    });
  } else if (getIsSubscriptionEmail(email) && !getIsOptinEmail(email)) {
    disabled = true;
    tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: `email-management.table.hoverActions.tooltip.${key}.subscriptionEmail`
    });
  }
  return {
    disabled,
    tooltip
  };
}
const getActionDefinition = ({
  action,
  email,
  auth,
  isProductReadOnly,
  isInternalSubscription
}) => {
  const actionObject = Object.assign({}, ACTION_MAP[action], {
    tooltip: null,
    disabled: false
  });
  const {
    user: {
      scopes
    },
    gates
  } = auth;
  const isUngatedForContextualAutomationV1 = gates['Email:ContextualAutomationV1'];
  const classicTemplateAccessDenied = !getIsDragDropEmail(email) && !canCreateClassicEmail(scopes);
  if ((email.isABEmail() || email.isABAutomatedEmail()) && !getHasFullEditorAccess(fromJS(auth)) && (isEdit(action) || isCloneOrConvert(action))) {
    const key = isCloneOrConvert(action) ? 'cloneOrConvertHigher' : 'disabledForUpgrade';
    actionObject.disabled = true;
    actionObject.tooltip = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `email-management.table.hoverActions.tooltip.${key}`
    });
  }
  if (email.isAutomated() && !getHasAutomatedEmailsAuth(fromJS(auth)) && !email.isLeadFlowEmail() && isEdit(action)) {
    const key = isUngatedForContextualAutomationV1 ? 'disabledForUpgradeStarter' : 'disabledForUpgrade';
    actionObject.disabled = true;
    actionObject.tooltip = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `email-management.table.hoverActions.tooltip.${key}`
    });
  }
  if (classicTemplateAccessDenied) {
    if (isEdit(action)) {
      actionObject.disabled = true;
      actionObject.tooltip = /*#__PURE__*/_jsx(DowngradeActionDisabledTooltip, {
        action: "edit"
      });
    }
    if (isCloneOrConvert(action) && !getIsConvertibleToDragAndDrop(email)) {
      actionObject.disabled = true;
      actionObject.tooltip = /*#__PURE__*/_jsx(DowngradeActionDisabledTooltip, {
        action: "clone"
      });
    }
  }
  if (isProductReadOnly && READ_ONLY_ACTIONS.indexOf(action) === -1) {
    actionObject.disabled = true;
    actionObject.tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
      message: "email-management.table.hoverActions.productIsReadOnlyBanner.manageTooltip"
    });
  }
  if (action === SAVE_AS_TEMPLATE) {
    const disabledReason = saveTemplateDisabled(email, null, scopes);
    if (disabledReason) {
      actionObject.disabled = true;
      actionObject.tooltip = disabledReason.tooltip;
    }
  }
  if (isContentUnsafe(email)) {
    let message = '';
    const key = isEmailInReview(email) ? 'inReview' : 'blocked';
    switch (action) {
      case EDIT:
        message = `email-management.table.hoverActions.tooltip.unsafe.${key}.edit_jsx`;
        actionObject.disabled = true;
        break;
      case CLONE_OR_CONVERT:
        actionObject.disabled = true;
        message = `email-management.table.hoverActions.tooltip.unsafe.${key}.clone_jsx`;
        break;
      case GENERATE_TRANSLATED_VERSION:
        actionObject.disabled = true;
        message = `email-management.table.hoverActions.tooltip.unsafe.${key}.generateTranslatedVersion_jsx`;
        break;
      case ARCHIVE:
        if (key === 'inReview') {
          actionObject.disabled = true;
          message = 'email-management.table.hoverActions.tooltip.unsafe.inReview.archive_jsx';
        }
        break;
      case DELETE:
        if (key === 'inReview') {
          actionObject.disabled = true;
          message = 'email-management.table.hoverActions.tooltip.unsafe.inReview.delete_jsx';
        }
        break;
      case VIEW_EMAIL:
        actionObject.disabled = true;
        message = `email-management.table.hoverActions.tooltip.unsafe.${key}.viewEmail_jsx`;
        break;
      default:
        break;
    }
    if (message) {
      actionObject.tooltip = /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: message,
        elements: {
          Link: props => {
            return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
              external: true,
              children: props.children
            }));
          }
        }
      });
    }
  }
  if (isCloneOrConvert(action)) {
    const {
      disabled: disabledCloneOrTranslate,
      tooltip: cloneOrTranslateTooltip
    } = disableCloneOrTranslate({
      defaultDisabled: actionObject.disabled,
      defaultTooltip: actionObject.tooltip,
      email,
      isInternalSubscription,
      isCloning: true
    });
    actionObject.disabled = disabledCloneOrTranslate;
    actionObject.tooltip = cloneOrTranslateTooltip;
  }
  if (action === GENERATE_TRANSLATED_VERSION) {
    if (!scopes.includes('email-auto-translate')) {
      actionObject.disabled = true;
    } else if (email.isRssEmail()) {
      actionObject.disabled = true;
      actionObject.tooltip = /*#__PURE__*/_jsx(ActionTooltip, {
        message: "email-management.table.hoverActions.tooltip.disabledTranslateType.rssEmail"
      });
    } else {
      const {
        disabled: disabledCloneOrTranslate,
        tooltip: cloneOrTranslateTooltip
      } = disableCloneOrTranslate({
        defaultDisabled: actionObject.disabled,
        defaultTooltip: actionObject.tooltip,
        email,
        isInternalSubscription,
        isCloning: false
      });
      actionObject.disabled = disabledCloneOrTranslate;
      actionObject.tooltip = cloneOrTranslateTooltip;
    }
  }
  return actionObject;
};
const ACTION_PREDICATES = {
  [ARCHIVE]: ({
    email,
    auth
  }) => {
    return all([!email.isArchived(), auth.user.canWrite()]);
  },
  [ASSIGN_TEAMS]: ({
    email,
    auth,
    teams
  }) => canAssignEmail(email, auth.user, auth.gates, teams),
  [MOVE_TO_FOLDER]: ({
    email,
    auth: {
      user,
      gates
    }
  }) => {
    return all([!email.isArchived(), user.canWrite(), !gates['Email:FrameworkPortalsWithNoFolder']]);
  },
  [GENERATE_TRANSLATED_VERSION]: ({
    auth: {
      user
    }
  }) => {
    return user.get('scopes').includes('email-auto-translate');
  },
  [SAVE_AS_TEMPLATE]: ({
    email,
    auth: {
      user
    }
  }) => {
    return all([user.get('scopes').includes('email-access'), getIsDragDropEmail(email)]);
  },
  [LOCKED_SAVE_AS_TEMPLATE]: ({
    email,
    auth: {
      user
    }
  }) => {
    return all([!user.get('scopes').includes('email-access'), getIsDragDropEmail(email)]);
  },
  [CLONE_OR_CONVERT]: ({
    auth: {
      user,
      gates
    }
  }) => {
    return all([user.canWrite(), canCreateDragDropEmail(Object.keys(gates), user.get('scopes'))]);
  },
  [DELETE]: ({
    email,
    auth: {
      user
    }
  }) => canDeleteEmail(email, user),
  [VIEW_PERFORMANCE]: ({
    email
  }) => !email.isDraft() || email.isErrored() || getIsAutomatedLike(email) || email.isBlogEmail() || email.isRssEmail(),
  [SUMMARIZE_PERFORMANCE]: ({
    email,
    auth: {
      gates
    },
    isCopilotEnabled
  }) => {
    return (!email.isDraft() || email.isErrored() || getIsAutomatedLike(email) || email.isBlogEmail() || email.isRssEmail()) && gates[gate('Copilot:MarketingEmailInsights')] && isCopilotEnabled;
  },
  [VIEW_INSIGHTS]: ({
    email,
    auth: {
      gates
    },
    isPreviewFooter
  }) => !isPreviewFooter && email.isPublished() && (email.isBatch() || email.isAutomated() || email.isLocalTime() || email.isABAutomatedEmail() || email.isABEmail()) && gates['Email:MessagingInsights'],
  [EDIT]: ({
    email,
    auth: {
      user,
      gates
    }
  }) => {
    const gatesAsKeys = Object.keys(gates);
    return all([canEdit(email, user, hasContextualAutomationGates(gatesAsKeys)), !hasEmailBeenCancelled(email), !email.isErrored(), !all([canCreateDragDropEmail(gatesAsKeys, user.get('scopes')), !getIsDragDropEmail(email), !canCreateClassicEmail(user.get('scopes'))])]);
  },
  [UNPUBLISH]: ({
    email,
    auth: {
      user
    }
  }) => {
    return all([email.isScheduled(), user.canPublish()]);
  },
  [UNARCHIVE]: ({
    email,
    auth: {
      user
    }
  }) => {
    return all([email.isArchived(), user.canWrite()]);
  },
  [VIEW_EMAIL]: ({
    email
  }) => {
    return email.isDraft() || email.isPublished() || email.isScheduled();
  },
  [MANAGE_LEADFLOW]: ({
    email
  }) => {
    return email.isLeadFlowEmail();
  },
  [VIEW_DETAILS]: () => {
    return true;
  }
};
const reduceToValidActions = ({
  email,
  auth,
  possibleActions,
  teams,
  isPreviewFooter,
  isCopilotEnabled
}) => {
  return possibleActions.reduce((validActions, action) => {
    let next = validActions;
    if (ACTION_PREDICATES[action]({
      email,
      auth,
      teams,
      isPreviewFooter,
      isCopilotEnabled
    })) {
      next = validActions.concat([action]);
    }
    return next;
  }, []);
};
const getEditActions = (email, auth, isPreviewFooter) => {
  return reduceToValidActions({
    email,
    auth,
    possibleActions: [VIEW_INSIGHTS, CLONE_OR_CONVERT, EDIT],
    isPreviewFooter
  });
};
const getPublishActions = ({
  email,
  auth,
  teams,
  isCopilotEnabled
}) => {
  return reduceToValidActions({
    email,
    auth,
    possibleActions: [MANAGE_LEADFLOW, VIEW_EMAIL, VIEW_PERFORMANCE, VIEW_DETAILS, SUMMARIZE_PERFORMANCE, SAVE_AS_TEMPLATE, LOCKED_SAVE_AS_TEMPLATE, ASSIGN_TEAMS, MOVE_TO_FOLDER, GENERATE_TRANSLATED_VERSION, ARCHIVE, UNARCHIVE, DELETE],
    teams,
    isCopilotEnabled
  });
};
function applyActionDividerOverrides(action, otherActions) {
  switch (action.name) {
    case SAVE_AS_TEMPLATE:
    case LOCKED_SAVE_AS_TEMPLATE:
      {
        const hasSummarizePerformanceAction = otherActions.some(({
          name
        }) => name === SUMMARIZE_PERFORMANCE);
        if (hasSummarizePerformanceAction) {
          return Object.assign({}, action, {
            divider: false
          });
        }
        return action;
      }
    default:
      return action;
  }
}
export default function getActions({
  email,
  auth,
  isPreviewFooter,
  isProductReadOnly,
  teams,
  isInternalSubscription,
  isCopilotEnabled
}) {
  const primaryActions = getEditActions(email, auth, isPreviewFooter).map(action => getActionDefinition({
    action,
    email,
    auth,
    isProductReadOnly,
    isInternalSubscription
  }));
  const secondaryActions = getPublishActions({
    email,
    auth,
    teams,
    isCopilotEnabled
  }).map(action => getActionDefinition({
    action,
    email,
    auth,
    isProductReadOnly
  }));
  return {
    primary: primaryActions,
    secondary: secondaryActions.map(action => applyActionDividerOverrides(action, secondaryActions))
  };
}